export const APP_NAME = "MosaicONE Marketing Website"

export const MEASUREMENT_ID = "G-SJ331RX5D1"
